const getFirstQueryValue = (value) => (Array.isArray(value) ? value[0] : value)

const normalizeQueryValue = (value) => {
	if (value === undefined || value === null) return ''
	return String(value).trim().toLowerCase()
}

const isTruthyQueryValue = (value) => {
	const normalized = normalizeQueryValue(getFirstQueryValue(value))
	return normalized === 'true' || normalized === '1'
}

const isDraftPerspective = (value) => {
	const normalized = normalizeQueryValue(getFirstQueryValue(value))
	return normalized === 'drafts' || normalized === 'previewdrafts'
}

export function usePreviewSanityQuery(query, params, options = {}) {
	const route = useRoute()
	const sanityConfig = useSanityConfig()

	const previewRequested = isTruthyQueryValue(route.query?.preview)
	const draftRequested = isTruthyQueryValue(route.query?.isDraft)
	const requestedDataset = getFirstQueryValue(route.query?.dataset)
	const requestedPerspective = getFirstQueryValue(route.query?.['sanity-preview-perspective'])

	const datasetMatches = !requestedDataset || requestedDataset === sanityConfig.dataset
	const shouldUseDrafts = datasetMatches && (isDraftPerspective(requestedPerspective) || (previewRequested && draftRequested))
	const queryOptions = shouldUseDrafts && !options.perspective ? { ...options, perspective: 'drafts' } : options

	if ((previewRequested || requestedPerspective) && !datasetMatches && import.meta.dev) {
		console.warn(`[sanity-preview] Ignoring preview dataset "${requestedDataset}" because this app is configured for "${sanityConfig.dataset}".`)
	}

	return useSanityQuery(query, params, queryOptions)
}
